// extracted by mini-css-extract-plugin
export default {"wrapper":"fD-z","viewport":"gD-z","container":"hD-z","slide":"iD-z"};